import { useQuery } from '@tanstack/react-query';

import { toastError } from 'common/toast';
import { getSettingsByNames } from 'api/settings';

import { APIKeys } from 'common/enum/api-keys.enum';

export const useSettings = () => {
  const { data, refetch, isFetching } = useQuery<Record<string, any>>({
    placeholderData: {},
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: [APIKeys.SETTINGS],
  });

  const fetchData = async (): Promise<Record<string, any>> => {
    try {
      const { settings } = await getSettingsByNames();

      return settings;
    } catch (error) {
      toastError('Failed to fetch settings', error);

      throw error;
    }
  };

  return {
    data,
    refetch,
    isLoading: isFetching,
  };
};
